<div fxLayout="row" 
     fxLayoutGap="20px" 
     style="font-size: 11px;"
     fxFlexFill>
    <extrato-conta-bancaria [extrato]="extrato" style="width: 1000px;"></extrato-conta-bancaria>
</div>

<br><br>
<div fxLayout="row" fxLayoutGap="50px" 
     style="margin-top: 30px; margin-bottom: 10px" 
     fxFlexFill>
    <div fxFlex="100%" fxLayoutAlign="center center">
        <button mat-raised-button 
                style="width: 240px; background-color: rgb(241,241,241);"
                (click)="cancelar()"  
                matTooltip="Fechar">
            Fechar
        </button>
    </div>
</div>